import { create } from "zustand";
import { persist } from "zustand/middleware";
import { Lang } from "./lang";

interface I18nStore {
	lang: Lang;
	setLang: (lang: Lang) => void;
}

export const useI18n = create(
	persist<I18nStore>(
		(set) => ({
			lang: Lang.en,
			setLang: (lang: Lang) => set({ lang }),
		}),
		{
			name: "i18n",
		},
	),
);
